<template>
    <div class="page bg-blue relative desktop-footer">
        <div class="bg-head-coin sm:block"></div>
        <div class="page-content sm:px-8">
            <NewTopbarBack class="sm:hidden" title="Home" :isShowOnlyLogo="true" :modalController="modalController"></NewTopbarBack>
            <TopBar class="hidden sm:block" :modalController="modalController"></TopBar>
            <div class="mt-7">
                <MenuDesktop activeMenu="none"></MenuDesktop>
            </div>
            <div class="sm:bg-white sm:rounded-25 mt-6 pb-1">
                <PathLink class="pt-5 pl-6" :pathLink1="pathLink"></PathLink>
                <div class="sm:bg-a-blue-1a326e sm:rounded-25 sm:m-5">
                    <div class="mt-8 text-center sm:pt-5 sm:mt-0">
                        <img class="h-20 m-auto" src="../../../assets/fgf/fgf-head.png" />
                        <div class="text-22 text-white mt-3.5">{{lbl.getfriend.invite_detail}}</div>
                        <div class="text-20 text-white mt-2 underline" @click="clickShowDetail()">{{lbl.getfriend.title}}</div>
                    </div>
                    <div class="bg-white mx-6 sm:mx-40 rounded-20 mt-11" v-if="missionItem">
                        <div class="relative -top-5 text-center">
                            <img class="h-10 m-auto" src="../../../assets/fgf/bg-btn-head.png"/>
                            <div class="absolute top-0 left-0 right-0 text-22 text-white pt-1.5">
                                {{lbl.getfriend.register_done}} {{missionItem.Current}}/{{missionItem.Value}} {{lbl.getfriend.person}}
                            </div>
                        </div>
                        <div  class="grid grid-cols-5 gap-2 mx-5 pb-2.5">
                            <div v-for="(v) in 10" :key="v" class="">
                                <img v-if="missionItem.Current >= v" class="h-12 mb-5 mx-auto" src="../../../assets/fgf/fgf-success.png" />
                                <img v-else class="h-12 mb-5 mx-auto" src="../../../assets/fgf/fgf-not-success.png" />
                            </div>
                        </div>
                    </div>
                    <div>
                        <img class="sm:hidden h-56 w-auto mx-auto" src="../../../assets/fgf/fgf-footer.png" />
                        <img class="hidden sm:block h-56 w-auto mx-auto" src="../../../assets/fgf/fgf-footer-desktop.svg" />
                    </div>
                    <div v-if="isLineBrowser" class="mt-4 pb-6">
                        <LineGetFriend></LineGetFriend>
                    </div>
                    <div v-else class="mt-4 pb-6 sm:pb-0 sm:relative" @click="gotoGetfriendSms()">
                        <div class="mx-5 sm:absolute right-0 left-0 bottom-40">
                            <div class="flex justify-center">
                                <button class="bg-a-gray-e9ecf5 rounded-full text-tc-blue-1 text-center text-20 px-4 py-1 w-full sm:w-250px cursor-pointer h-45px">
                                    {{ lbl.getfriend.invite_friend_sms }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <BottomBar></BottomBar>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>

//component
import TopBar from '@/components/Layout/TopBar/TopBar.vue';
import NewTopbarBack from '@/components/Layout/TopBar/NewTopbarBack.vue'
import LineGetFriend from "@/components/Feature/LineGetFriend/LineGetFriend.vue";
import PathLink from '../component/PathLink.vue';
import MenuDesktop from '@/components/Layout/MenuDesktop/MenuDesktop.vue';
import BottomBar from '@/components/Layout/BottomBar/BottomBar.vue';
//service
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";
//mixin
import ModalMixin from "@/mixin/ModalMixin.js";
import LocaleMixin from '@/mixin/LocaleMixin.js'
import Util from "../../../helper/Utility.js";
import Account from '@/helper/AccountHelper';
import CacheHelper from '@/helper/CacheHelper'

export default ({
    name: 'getfriend',
    mixins: [ModalMixin, LocaleMixin],
    components: {
        TopBar,
        NewTopbarBack,
        LineGetFriend,
        PathLink,
        MenuDesktop,
        BottomBar
    },
    data: function() {
        return {
            mission: [],
            missionItem: null,
            isLineBrowser: false,
            pathLink: {
                name: '',
                url: ''
            }
        }
    },
    created: function(){
        this.pathLink.name = this.lbl.getfriend.friend_get_friend
    },
    mounted: function () {
        this.getMission();
        this.isLineBrowser = false;
        if(Util.isLineBrowser() || this.isLoginLine() || this.isRegisterLine()){
            this.isLineBrowser = true;
        }
    },
    methods: {
        isRegisterLine: function(){
            let cache = new CacheHelper('local');
            let registerChannel = cache.getCache('register_channel');
            if(registerChannel == 'line'){
                return true
            }
            return false
        },
        isLoginLine: function(){
            if(Account.getCacheUser().loginChanel == 'line'){
                return true
            }
            return false
        },
        getMission: function() {
            this.loadingModal.show();
            var key = this.$route.params.key;
            return new Promise((resolve) => {
                BzbsProfile.getMissionList(key)
                    .subscribe ({
                        next: (mission) => {
                            this.mission = mission[0];
                            this.missionItem = this.mission.missions[0];
                            this.loadingModal.hide();
                            resolve();
                        },
                        error: (err) => {
                            resolve();
                            this.loadingModal.hide();
                            this.errorApi(err);
                        }
                    })
            });
        },
        clickShowDetail: function () {
            this.alertDescription
                .clearModal()
                .setTitle(this.lbl.getfriend.event_description)
                .setMsg(this.mission.description)
                .show();
        },
        gotoGetfriendSms: function () {

            var path = "/getfriendsms/" + this.$route.params.key;
            this.$router.push(path);
        }
    }
})
</script>
<style lang="scss" scoped>
    .bg-btn-head {
        background-image: url('../../../assets/fgf/bg-btn-head.png');
    }
</style>
